'use client';

import React from 'react';
import { Download } from 'lucide-react';
import { sendGtmEvent } from '@/lib/gtm/gtm';
import { cn } from '@/lib/twUtils';

/**
 * Il PDF lo genera il backend — uno solo, identico per landing e app, con
 * testata Trovanorma, fonti con i link ufficiali e l'invito a porre il quesito
 * in chiusura (`docs/news.md` §8). Qui c'è solo il link: un PDF che gira per
 * lo studio è un annuncio che non paghiamo.
 */
export const newsPdfUrl = (slug: string) =>
  `${process.env.NEXT_PUBLIC_API_BASE_URL}/v1/landing/news/articles/${encodeURIComponent(slug)}/pdf`;

interface NewsDownloadButtonProps {
  slug: string;
  position: 'header' | 'footer';
  className?: string;
}

const NewsDownloadButton = ({ slug, position, className }: NewsDownloadButtonProps) => (
  <a
    href={newsPdfUrl(slug)}
    target="_blank"
    rel="noopener"
    download={`trovanorma-${slug}.pdf`}
    onClick={() =>
      sendGtmEvent({ event: 'news_pdf_download', news_slug: slug, news_cta_position: position })
    }
    className={cn(
      'inline-flex items-center gap-1.5 rounded-ds-sm border border-edge bg-white px-3 py-1.5 text-[0.8125rem] font-semibold text-primary transition-colors ds-focus hover:border-edge-strong print:hidden',
      className
    )}
  >
    <Download className="h-3.5 w-3.5" aria-hidden="true" />
    Scarica PDF
  </a>
);

export default NewsDownloadButton;
